// app/constants/route-list-dynamic.ts

export const ROUTE_LIST_DYNAMIC = [
    {
      label: "Jasa Bangun Rumah Bekasi",
      path: "/jasa-bangun-rumah-di-bekasi",
    },
    {
        label: "Jasa Renovasi Rumah Bekasi",
        path: "/jasa-renovasi-rumah-di-bekasi",
      },
      {
        label: "Jasa Arsitek Rumah Bekasi",
        path: "/jasa-arsitek-rumah-di-bekasi",
      },
      {
        label: "Jasa Arsitek Rumah Jakarta Pusat",
        path: "/jasa-arsitek-rumah-di-jakarta-pusat",
      },
      {
        label: "Jasa Arsitek Rumah Jakarta Barat",
        path: "/jasa-arsitek-rumah-di-jakarta-barat",
      },
   
  ];
  